import './styles.css';
import { App } from './app.js';

const root = document.getElementById('app');
if (!root) throw new Error('Missing #app root element');

const app = new App(root);

if (import.meta.env.DEV) {
  // Dev-only handle so a level can be driven and inspected from the console (or
  // from an automated browser check) without clicking through the UI.
  (window as unknown as { game: App }).game = app;
}
